export default {
  ja:[
    "ζ*'ヮ')ζ＜ アイテムが発送されました、届いたらReceivedボタンを押してください！",
    "注意！",
    "本当にアイテムが届きましたか？",
    "受取完了",
    "閉じる",
  ],
  en: [
    `ζ*'ヮ')ζ＜ The item hαs been shipped! Please click the "Received" button when the item arrives!`,
    "Caution!",
    "Have you received the item??",
    "Received",
    "Cancel"
  ]
}
